module.exports = __webpack_public_path__ + "static/media/sunny.00a0bef8.svg";